import { z } from "zod";

export const ZMyndighetskravSchema = z.object({
  // 2
  isActive: z.boolean().default(true),
  tekst: z.string(),
  forskrifter: z.object({
    // 2.1
    isActive: z.boolean().default(true),
    tekst: z.string(),
  }),
  prosjektspesifikkeKrav: z.object({
    // 2.2
    isActive: z.boolean().default(true),
    tekst: z.string(),
  }),
  uavhengigKontroll: z.object({
    // 2.3
    isActive: z.boolean().default(true),
    tekst: z.string(),
    tiltaksklasseEn: z.object({
      // 2.3.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    tiltaksklasseToEllerTre: z.object({
      // 2.3.2
      isActive: z.boolean().default(true),
      tekst: z.string(),
    }),
  }),
  grensesnitt: z.object({
    // 2.4
    isActive: z.boolean().default(true),
    tekst: z.string(),
  }),
});

export type IMyndighetskravSchema = z.infer<typeof ZMyndighetskravSchema>;
